import BaseApi from './baseApi';
import ICustomer from '../models/ICustomer';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class CustomerApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Customers");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCustomers() : Promise<ICustomer[]> {
        let json : string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var customer: ICustomer[] = [];
            customer = response.data as ICustomer[];
            return customer;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetCustomersByCompanyId(idCompany: string) : Promise<ICustomer[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCustomer(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var customer: ICustomer[] = [];
            customer = response.data as ICustomer[];
            return customer;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCustomer(customer: ICustomer) : Promise<string> {
        const json = this.getJsonSave(customer);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCustomer(customer: ICustomer) : Promise<boolean> {
        const json = this.getJsonUpdate(customer);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCustomer(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Customers",
            "conditions": [{
                "Item1": "Customers",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(customer: ICustomer) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": customer.name
            }, {
                "Item1": "fiscalIdentifier",
                "Item2": customer.fiscalIdentifier
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": customer.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": customer.phoneNumber
            }, {
                "Item1": "idCompany",
                "Item2": customer.idCompany
            }, {
                "Item1": "idUser",
                "Item2": customer.idUser
            }, {
                "Item1": "RequireInboundFields",
                "Item2": customer.requireInboundFields
            }, {
                "Item1": "PalletQr",
                "Item2": customer.palletQr
            }, {
                "Item1": "NeededPalletId",
                "Item2": customer.neededPalletId
            }, {
                "Item1": "IdListCountry",
                "Item2": customer.idListCountry
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Customers"
        };
        return json;
    }

    private getJsonUpdate(customer: ICustomer) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": customer.name
            }, {
                "Item1": "fiscalIdentifier",
                "Item2": customer.fiscalIdentifier
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": customer.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": customer.phoneNumber
            }, {
                "Item1": "IdCompany",
                "Item2": customer.idCompany
            }, {
                "Item1": "IdUser",
                "Item2": customer.idUser
            }, {
                "Item1": "RequireInboundFields",
                "Item2": customer.requireInboundFields
            }, {
                "Item1": "PalletQr",
                "Item2": customer.palletQr
            }, {
                "Item1": "NeededPalletId",
                "Item2": customer.neededPalletId
            }, {
                "Item1": "IdListCountry",
                "Item2": customer.idListCountry
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Customers",
            "keyvalue": customer.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Customers",
                "Item2": "id"
            }, {
                "Item1": "Customers",
                "Item2": "name"
            }, {
                "Item1": "Customers",
                "Item2": "fiscalIdentifier"
            }, {
                "Item1": "Customers",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Customers",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Customers",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "Customers",
                "Item2": "idUser"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Roles",
                "Item2": "id as idRole"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }, {
                "Item1": "Customers",
                "Item2": "RequireInboundFields"
            }, {
                "Item1": "Customers",
                "Item2": "PalletQr"
            }, {
                "Item1": "Customers",
                "Item2": "NeededPalletId"
            }, {
                "Item1": "Customers",
                "Item2": "IdListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }],
            "tables": [{
                "Item1": "Customers"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "ListCountries"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }],
            "joins": [{
                "Item1": "Customers",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdUser",
                "Item3": "Users",
                "Item4": "Id"
            }, {
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Customers",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "Customers.name"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCustomer(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Customers",
                "Item2": "id"
            }, {
                "Item1": "Customers",
                "Item2": "name"
            }, {
                "Item1": "Customers",
                "Item2": "fiscalIdentifier"
            }, {
                "Item1": "Customers",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Customers",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Customers",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "Customers",
                "Item2": "idUser"
            }, {
                "Item1": "Users",
                "Item2": "userName"
            }, {
                "Item1": "Roles",
                "Item2": "id as idRole"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }, {
                "Item1": "Customers",
                "Item2": "RequireInboundFields"
            }, {
                "Item1": "Customers",
                "Item2": "PalletQr"
            }, {
                "Item1": "Customers",
                "Item2": "NeededPalletId"
            }, {
                "Item1": "Customers",
                "Item2": "IdListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }],
            "tables": [{
                "Item1": "Customers"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "ListCountries"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "Users"
            }, {
                "Item1": "Roles"
            }],
            "joins": [{
                "Item1": "Customers",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "Customers",
                "Item2": "IdUser",
                "Item3": "Users",
                "Item4": "Id"
            }, {
                "Item1": "Users",
                "Item2": "IdRole",
                "Item3": "Roles",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Customers",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Customers",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany
            }]
        };
        return json;
    }
}
